var _g, _path, _path2, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 33,
    viewBox: "0 0 38 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1640_38223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1975 20.4456C36.0656 20.0455 35.9042 19.6585 35.7168 19.287C35.5892 19.0338 35.3134 18.8981 35.0331 18.9386C34.3485 19.0382 33.5851 18.7923 33.0116 18.2188C32.4382 17.6453 32.1922 16.8814 32.2918 16.1973C32.3323 15.9166 32.1966 15.6412 31.9434 15.5136C31.5719 15.3262 31.1854 15.1653 30.7848 15.0329C30.5181 14.945 30.2263 15.0372 30.0591 15.2629C29.6461 15.8214 28.93 16.191 28.115 16.191C27.2999 16.191 26.5839 15.8214 26.1708 15.2629C26.0036 15.0372 25.7118 14.945 25.4451 15.0329C25.0451 15.1648 24.6581 15.3262 24.287 15.5131C24.0338 15.6407 23.8981 15.9166 23.9386 16.1973C24.0382 16.8819 23.7923 17.6453 23.2188 18.2188C22.6453 18.7923 21.8814 19.0382 21.1973 18.9386C20.9166 18.8981 20.6412 19.0338 20.5136 19.287C20.3262 19.6585 20.1653 20.0451 20.0329 20.4451C19.945 20.7118 20.0372 21.0036 20.2629 21.1708C20.8214 21.5839 21.191 22.2999 21.191 23.115C21.191 23.93 20.8214 24.6461 20.2629 25.0591C20.0372 25.2263 19.945 25.5181 20.0329 25.7848C20.1648 26.1849 20.3262 26.5719 20.5136 26.9429C20.6412 27.1961 20.9171 27.3319 21.1973 27.2913C21.8819 27.1917 22.6453 27.4377 23.2188 28.0112C23.7923 28.5847 24.0382 29.3485 23.9386 30.0326C23.8981 30.3134 24.0338 30.5887 24.287 30.7168C24.6585 30.9042 25.0451 31.0651 25.4451 31.1975C25.7118 31.2854 26.0036 31.1932 26.1708 30.9675C26.5839 30.409 27.2999 30.0394 28.115 30.0394C28.93 30.0394 29.6461 30.409 30.0591 30.9675C30.2263 31.1932 30.5181 31.2854 30.7848 31.1975C31.1849 31.0656 31.5719 30.9042 31.9434 30.7168C32.1966 30.5892 32.3323 30.3134 32.2918 30.0331C32.1922 29.3485 32.4382 28.5851 33.0116 28.0116C33.5851 27.4382 34.3485 27.1922 35.0331 27.2918C35.3138 27.3323 35.5892 27.1966 35.7168 26.9434C35.9042 26.5719 36.0651 26.1849 36.1975 25.7848C36.2854 25.5181 36.1932 25.2263 35.9675 25.0591C35.409 24.6461 35.0394 23.93 35.0394 23.115C35.0394 22.2999 35.409 21.5839 35.9675 21.1708C36.1932 21.0036 36.2854 20.7123 36.1975 20.4456ZM28.1913 27.1328C25.9118 27.1753 24.0556 25.3186 24.0976 23.0391C24.1372 20.891 25.8906 19.1377 28.0386 19.0981C30.3181 19.0556 32.1744 20.9123 32.1323 23.1918C32.0927 25.3398 30.3394 27.0932 28.1913 27.1328Z",
    fill: "url(#paint0_linear_1640_38223)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18.7282H10.875C4.86899 18.7282 0 23.5576 0 29.5151V31.2299C0 32.2075 0.799 33 1.78461 33H27.2154C28.201 33 29 32.2075 29 31.2299V29.5151C29 23.5576 24.1311 18.7282 18.125 18.7282ZM14.5001 17.0997C19.2605 17.0997 23.1197 13.2718 23.1197 8.54985C23.1197 3.8279 19.2605 0 14.4999 0C9.73941 0 5.88023 3.8279 5.88023 8.54985C5.88023 13.2718 9.73941 17.0997 14.4999 17.0997H14.5001Z",
    fill: "url(#paint1_linear_1640_38223)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1640_38223",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.125 18.7282H10.875C4.86899 18.7282 0 23.5576 0 29.5151V31.2299C0 32.2075 0.799 33 1.78461 33H27.2154C28.201 33 29 32.2075 29 31.2299V29.5151C29 23.5576 24.1311 18.7282 18.125 18.7282ZM14.5001 17.0997C19.2605 17.0997 23.1197 13.2718 23.1197 8.54985C23.1197 3.8279 19.2605 0 14.4999 0C9.73941 0 5.88023 3.8279 5.88023 8.54985C5.88023 13.2718 9.73941 17.0997 14.4999 17.0997H14.5001Z",
    fill: "url(#paint2_linear_1640_38223)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1640_38223)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.52,
    filter: "url(#filter1_f_1640_38223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1975 20.4456C36.0656 20.0455 35.9042 19.6585 35.7168 19.287C35.5892 19.0338 35.3134 18.8981 35.0331 18.9386C34.3485 19.0382 33.5851 18.7923 33.0116 18.2188C32.4382 17.6453 32.1922 16.8814 32.2918 16.1973C32.3323 15.9166 32.1966 15.6412 31.9434 15.5136C31.5719 15.3262 31.1854 15.1653 30.7848 15.0329C30.5181 14.945 30.2263 15.0372 30.0591 15.2629C29.6461 15.8214 28.93 16.191 28.115 16.191C27.2999 16.191 26.5839 15.8214 26.1708 15.2629C26.0036 15.0372 25.7118 14.945 25.4451 15.0329C25.0451 15.1648 24.6581 15.3262 24.287 15.5131C24.0338 15.6407 23.8981 15.9166 23.9386 16.1973C24.0382 16.8819 23.7923 17.6453 23.2188 18.2188C22.6453 18.7923 21.8814 19.0382 21.1973 18.9386C20.9166 18.8981 20.6412 19.0338 20.5136 19.287C20.3262 19.6585 20.1653 20.0451 20.0329 20.4451C19.945 20.7118 20.0372 21.0036 20.2629 21.1708C20.8214 21.5839 21.191 22.2999 21.191 23.115C21.191 23.93 20.8214 24.6461 20.2629 25.0591C20.0372 25.2263 19.945 25.5181 20.0329 25.7848C20.1648 26.1849 20.3262 26.5719 20.5136 26.9429C20.6412 27.1961 20.9171 27.3319 21.1973 27.2913C21.8819 27.1917 22.6453 27.4377 23.2188 28.0112C23.7923 28.5847 24.0382 29.3485 23.9386 30.0326C23.8981 30.3134 24.0338 30.5887 24.287 30.7168C24.6585 30.9042 25.0451 31.0651 25.4451 31.1975C25.7118 31.2854 26.0036 31.1932 26.1708 30.9675C26.5839 30.409 27.2999 30.0394 28.115 30.0394C28.93 30.0394 29.6461 30.409 30.0591 30.9675C30.2263 31.1932 30.5181 31.2854 30.7848 31.1975C31.1849 31.0656 31.5719 30.9042 31.9434 30.7168C32.1966 30.5892 32.3323 30.3134 32.2918 30.0331C32.1922 29.3485 32.4382 28.5851 33.0116 28.0116C33.5851 27.4382 34.3485 27.1922 35.0331 27.2918C35.3138 27.3323 35.5892 27.1966 35.7168 26.9434C35.9042 26.5719 36.0651 26.1849 36.1975 25.7848C36.2854 25.5181 36.1932 25.2263 35.9675 25.0591C35.409 24.6461 35.0394 23.93 35.0394 23.115C35.0394 22.2999 35.409 21.5839 35.9675 21.1708C36.1932 21.0036 36.2854 20.7123 36.1975 20.4456ZM28.1913 27.1328C25.9118 27.1753 24.0556 25.3186 24.0976 23.0391C24.1372 20.891 25.8906 19.1377 28.0386 19.0981C30.3181 19.0556 32.1744 20.9123 32.1323 23.1918C32.0927 25.3398 30.3394 27.0932 28.1913 27.1328Z",
    fill: "url(#paint3_linear_1640_38223)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1640_38223",
    x: 19,
    y: 14,
    width: 18.2305,
    height: 18.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.867 0 0 0 0 0.525 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1640_38223"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1640_38223",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1640_38223",
    x: 18,
    y: 13,
    width: 20.2305,
    height: 20.2305,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_1640_38223"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1640_38223",
    x1: 33.8528,
    y1: 17.3776,
    x2: 22.3771,
    y2: 28.8533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFF96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC656"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1640_38223",
    x1: 0,
    y1: 16.5001,
    x2: 29,
    y2: 16.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFEF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1640_38223",
    x1: 0,
    y1: 16.5001,
    x2: 29,
    y2: 16.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2F9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1640_38223",
    x1: 33.8528,
    y1: 17.3776,
    x2: 22.3771,
    y2: 28.8533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFF96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC656"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuProfile);
export default __webpack_public_path__ + "static/media/menu-profile.039616bfafda550fc04a3787771e9d7d.svg";
export { ForwardRef as ReactComponent };